module.exports = __webpack_public_path__ + "images/button-square-light-grey.svg";